module.exports = __webpack_public_path__ + "static/media/jordan_empower.2056dd48.png";